/**
 * Counter for reusing borrower data fetched earlier on the same page.
 *
 * plugins/072.data-generation.js advances it on every in-app navigation, and on every non-GET
 * request through $axios or $axiosWithRetry, both when it is sent and when it settles. Data fetched
 * at the current generation has seen no navigation or write since its request started.
 */
let generation = 0

export function currentGeneration() {
  return generation
}

export function nextGeneration() {
  generation++
}
